import React from 'react';
import ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.min.css';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import App from './App';

// RTL emotion cache – wraps the ENTIRE app so that all MUI portal styles
// (Dialog, Snackbar, Menu, Popover, …) go through the RTL stylis plugin.
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

ReactDOM.render(
  <CacheProvider value={cacheRtl}>
    <App />
  </CacheProvider>,
  document.getElementById('root')
);

// רישום Service Worker ל-PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
